/* ==========================================================
   product-filter-common.js
   Shared Product Filter Functions
   Refactored from productfilter.js
   ========================================================== */

(function ($, window, document) {
    "use strict";

    window.ProductFilterCommon = window.ProductFilterCommon || {};

    let common = window.ProductFilterCommon;


    /* -------------------------------------------------------
       Global State
       ------------------------------------------------------- */

    common.appliedFilterObject = {};


    /* -------------------------------------------------------
       Build Selected Filters
       ------------------------------------------------------- */

    common.getSelectedFilters = function () {

        let selectedFilters = {};

        $('.product-filter-btn.product-filter-btn--is-active').each(function () {

            let parentAttrKey = $(this)
                .parents('.js-product-filter-item')
                .attr('data-filter-group');

            if (!selectedFilters.hasOwnProperty(parentAttrKey)) {
                selectedFilters[parentAttrKey] = [];
            }

            selectedFilters[parentAttrKey].push(
                $(this)
                    .attr('data-filter-name')
                    .toLowerCase()
            );

        });

        return selectedFilters;
    };


    /* -------------------------------------------------------
       Apply Main Product Filter
       ------------------------------------------------------- */

    common.applyFilter = function (selectedFilters) {

        let $filteredResults = $('.productBoxWrapper');


        $.each(selectedFilters, function (name, filterValues) {

            $filteredResults = $filteredResults.filter(function (_index, product) {

                let matched = false;

                let totalValues = $(product)
                    .data('filter-group-' + name);

                let currentKeyValues = [];

                currentKeyValues.push(totalValues);


                $.each(currentKeyValues, function (_, currentFilterValue) {

                    if (currentFilterValue !== undefined) {

                        currentFilterValue =
                            currentFilterValue.toString();

                    }


                    if ($.inArray(currentFilterValue, filterValues) !== -1) {

                        matched = true;

                        return false;

                    }


                    let resultNew =
                        typeof currentFilterValue === 'string'
                            ? currentFilterValue.split('|')
                            : [];


                    $.each(resultNew, function (_newIndex, splittedValue) {

                        if ($.inArray(splittedValue, filterValues) !== -1) {

                            matched = true;

                            return false;

                        }

                    });

                });


                return matched;

            });

        });


        if (window.matchMedia('(max-width:991px)').matches) {

            $('.productBoxWrapper')
                .addClass('mobActive')
                .filter($filteredResults)
                .removeClass('mobActive');

        }


        $('.productBoxWrapper')
            .addClass('hidden')
            .filter($filteredResults)
            .removeClass('hidden');


        common.hideEmptyHeading();
        common.updateFilterText();
        common.disableEmptyCategories(selectedFilters);
        common.activeLabelAppend(selectedFilters);

    };


    /* -------------------------------------------------------
       Mobile CTA Filter Count
       ------------------------------------------------------- */

    common.applyFilterMobCta = function (selectedFilters) {

        let $filteredResults = $('.productBoxWrapper');


        $.each(selectedFilters, function (name, filterValues) {

            $filteredResults =
                $filteredResults.filter(function (_index, product) {

                    let matched = false;

                    let totalValues =
                        $(product).data('filter-group-' + name);

                    let currentKeyValues = [];

                    currentKeyValues.push(totalValues);


                    $.each(currentKeyValues, function (_, currentFilterValue) {

                        if (currentFilterValue !== undefined) {

                            currentFilterValue =
                                currentFilterValue.toString();

                        }


                        if ($.inArray(currentFilterValue, filterValues) !== -1) {

                            matched = true;

                            return false;

                        }


                        let resultNew =
                            typeof currentFilterValue === 'string'
                                ? currentFilterValue.split('|')
                                : [];


                        $.each(resultNew, function (_index, splittedValue) {

                            if ($.inArray(splittedValue, filterValues) !== -1) {

                                matched = true;

                                return false;

                            }

                        });

                    });


                    return matched;

                });

        });


        $('.productBoxWrapper')
            .addClass('mobActive')
            .filter($filteredResults)
            .removeClass('mobActive');

    };


    /* -------------------------------------------------------
       Hide Empty Product Category Heading
       ------------------------------------------------------- */

    common.hideEmptyHeading = function () {

        $('.js-product-filter-family').each(function () {

            let $this = $(this);

            let $products =
                $this.find('.productBoxWrapper');


            if ($products.length === 0) {

                return;

            }


            if ($products.filter('.hidden').length === $products.length) {

                $this.addClass('hidden');

            } else {

                $this.removeClass('hidden');

            }

        });

    };


    /* -------------------------------------------------------
       Product Count
       ------------------------------------------------------- */

    common.updateFilterText = function () {

        let totalProducts =
            $('.productBoxWrapper').length;

        let hiddenProducts =
            $('.productBoxWrapper[class*="hidden"]').length;

        let visibleProducts =
            totalProducts - hiddenProducts;


        $('.productCount')
            .text(visibleProducts);

    };


    /* -------------------------------------------------------
       Mobile Product Count
       ------------------------------------------------------- */

    common.updateFilterText4MobBtn = function () {

        let totalVisibleProducts = 0;


        $('.js-product-filter-family').each(function () {

            let $this = $(this);

            let categoryCount =
                $this.find('.productBoxWrapper').length;

            let hiddenCount =
                $this.find(
                    '.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="mobActive"], .productBoxWrapper[class*="hidden"]'
                ).length;


            totalVisibleProducts +=
                categoryCount - hiddenCount;

        });


        $('.mobActiveProductsCount')
            .text(totalVisibleProducts);

    };


    /* -------------------------------------------------------
       Category Count
       ------------------------------------------------------- */

    common.updateCategoryCount = function () {

        $('.js-product-filter-family').each(function () {

            let $this = $(this);

            let categoryCount =
                $this.find('.productBoxWrapper').length;

            let hiddenCount =
                $this.find(
                    '.productBoxWrapper[class*="hidden"], .productBoxWrapper[style*="display: none"]'
                ).length;


            let visible =
                categoryCount - hiddenCount;


            $this.find('.categoryProductsCount')
                .text('(' + visible + ')');

        });

    };


    /* -------------------------------------------------------
       Hide Zero Product Cards
       ------------------------------------------------------- */

    common.hideZeroCard = function () {

        $('.ProductDetailCard').each(function () {

            let $card = $(this);

            let countText =
                $card.find('.categoryProductsCount')
                    .text()
                    .trim();


            if (countText === "(0)") {

                $card.find('.row')
                    .addClass('d-none');

            } else {

                $card.find('.row')
                    .removeClass('d-none');

            }

        });


        let allCardsHidden =
            $('.ProductDetailCard.js-product-filter-family')
                .filter(function () {

                    let isCardHidden =
                        $(this).hasClass('hidden') ||
                        $(this).is(':hidden');

                    let hasHiddenChildren =
                        $(this).find('.d-none').length > 0;


                    return isCardHidden || hasHiddenChildren;

                }).length ===
            $('.ProductDetailCard.js-product-filter-family').length;


        if (allCardsHidden) {

            $('.noProductmsg')
                .removeClass('noProductmsg');

            $('.no_products_match')
                .addClass('noProductmsg');

        } else {

            $('.noProductmsg')
                .removeClass('noProductmsg');

        }

    };


    /* -------------------------------------------------------
       Initial Category Count
       ------------------------------------------------------- */

    common.updateCategoryCountOnTargetFilter = function () {

        setTimeout(function () {

            $('.js-product-filter-family').each(function () {

                let $this = $(this);

                let categoryCount =
                    $this.find('.productBoxWrapper').length;


                let hiddenCount =
                    $this.find(
                        '.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="hidden"]'
                    ).length;


                let visible =
                    categoryCount - hiddenCount;


                $this.find('.categoryProductsCount')
                    .text('(' + visible + ')');

            });

        }, 500);

    };


    /* -------------------------------------------------------
       Append Active Filter Labels
       ------------------------------------------------------- */

    common.activeLabelAppend = function (selectedFilters) {

        $('.filter-tags').empty();


        for (let key in selectedFilters) {

            $('.product-filter-item[data-filter-group="' + key + '"]')
                .find('.product-filter-btn.product-filter-btn--is-active')
                .each(function () {

                    let innerText =
                        $(this).text();


                    $('.product-filter-item[data-filter-group="' + key + '"]')
                        .find('.filter-tags')
                        .append(
                            '<li>' +
                            innerText.split('-').join(' ') +
                            '</li>'
                        );

                });

        }


        if ($('.filter-tags li').length > 1) {

            $('.filter-tags li:not(:last-child)')
                .addClass('comma');

        }

    };


    /* -------------------------------------------------------
       Disable Empty Categories / Filters
       Updated Logic
       ------------------------------------------------------- */

    common.disableEmptyCategories = function (selectedFilters) {

        /*
         * Start with all filter buttons enabled.
         */
        $('.product-filter-btn')
            .removeClass('disabled')
            .prop('disabled', false);


        /*
         * If no filters are selected,
         * everything stays enabled.
         */
        if (Object.keys(selectedFilters).length === 0) {

            return;

        }


        /*
         * For every NON-selected filter option:
         *
         * Check whether there is at least one product that:
         *
         * 1. Matches ALL currently selected filters
         * 2. Also contains this filter option
         *
         * If such a product exists -> enable the option.
         * Otherwise -> disable the option.
         */

        $('.product-filter-btn:not(.product-filter-btn--is-active)').each(function () {

            let $button = $(this);


            /*
             * Get candidate filter value.
             *
             * Example:
             * data-filter-name="red"
             */
            let filterValue =
                String(
                    $button.attr('data-filter-name') || ''
                ).toLowerCase();


            /*
             * Get candidate filter group.
             */
            let filterGroup =
                $button
                    .closest('.js-product-filter-item')
                    .attr('data-filter-group');


            let hasMatchingProduct = false;


            /*
             * Check every product.
             */
            $('.productBoxWrapper').each(function () {

                let $product = $(this);

                let productMatchesSelectedFilters = true;


                /*
                 * First check whether this product matches
                 * ALL currently selected filter groups.
                 */
                $.each(
                    selectedFilters,
                    function (selectedGroup, selectedValues) {

                        let productValue =
                            $product.attr(
                                'data-filter-group-' + selectedGroup
                            );


                        /*
                         * Product does not have this filter group/value.
                         */
                        if (
                            typeof productValue === 'undefined' ||
                            productValue === ''
                        ) {

                            productMatchesSelectedFilters = false;

                            return false;

                        }


                        /*
                         * Product can contain multiple values:
                         *
                         * data-filter-group-color="red|blue|green"
                         */
                        let productValues =
                            String(productValue)
                                .toLowerCase()
                                .split('|')
                                .map(function (value) {

                                    return value.trim();

                                });


                        /*
                         * Within the SAME filter group:
                         *
                         * Selected values use OR logic.
                         *
                         * Example:
                         *
                         * color = red + blue
                         *
                         * Product matching either red OR blue
                         * satisfies this group.
                         */
                        let selectedGroupMatches =
                            selectedValues.some(function (selectedValue) {

                                return productValues.indexOf(
                                    String(selectedValue).toLowerCase()
                                ) !== -1;

                            });


                        /*
                         * Product does not match
                         * this selected group.
                         */
                        if (!selectedGroupMatches) {

                            productMatchesSelectedFilters = false;

                            return false;

                        }

                    }
                );


                /*
                 * Product must first match
                 * ALL selected filters.
                 */
                if (!productMatchesSelectedFilters) {

                    return;

                }


                /*
                 * Now check whether this SAME product
                 * contains the filter option we are testing.
                 */
                let candidateValue =
                    $product.attr(
                        'data-filter-group-' + filterGroup
                    );


                if (
                    typeof candidateValue !== 'undefined' &&
                    candidateValue !== ''
                ) {

                    let candidateValues =
                        String(candidateValue)
                            .toLowerCase()
                            .split('|')
                            .map(function (value) {

                                return value.trim();

                            });


                    /*
                     * Candidate option exists on a product
                     * that already matches all selected filters.
                     */
                    if (
                        candidateValues.indexOf(filterValue) !== -1
                    ) {

                        hasMatchingProduct = true;

                        return false;

                    }

                }

            });


            /*
             * Disable only if there is no product that supports:
             *
             * Current selected filters
             * +
             * This candidate filter option.
             */
            if (hasMatchingProduct) {

                $button
                    .removeClass('disabled')
                    .prop('disabled', false);

            } else {

                $button
                    .addClass('disabled')
                    .prop('disabled', true);

            }

        });


        /*
         * Keep all selected buttons enabled.
         */
        $('.product-filter-btn.product-filter-btn--is-active')
            .removeClass('disabled')
            .prop('disabled', false);


        /*
         * Disable parent filter groups only when
         * every child option is disabled.
         */
        common.disableParent();

    };


    /* -------------------------------------------------------
       Disable Parent Filter Group
       ------------------------------------------------------- */

    common.disableParent = function () {

        $('.product-filter-item').each(function () {

            let $parent = $(this);

            let $buttons =
                $parent.find('.product-filter-btn');


            if ($buttons.length === 0) {

                return;

            }


            if (
                $buttons.filter('.disabled').length ===
                $buttons.length
            ) {

                $parent
                    .addClass('disabled')
                    .prop('disabled', true);

            } else {

                $parent
                    .removeClass('disabled')
                    .prop('disabled', false);

            }

        });

    };


    /* -------------------------------------------------------
       Restore Selected Filters Object
       ------------------------------------------------------- */

    common.storeAppliedFilters = function (selectedFilters) {

        common.appliedFilterObject = {};


        for (let key in selectedFilters) {

            common.appliedFilterObject[key] =
                selectedFilters[key];

        }

    };


    /* -------------------------------------------------------
       Reset Common Filter State
       ------------------------------------------------------- */

    common.resetFilterUI = function () {

        $('.product-filter-applied-list')
            .empty();


        $('.product-filter-btn')
            .removeClass('product-filter-btn--is-active')
            .removeClass('disabled')
            .prop('disabled', false);


        $('.productBoxWrapper')
            .removeClass('hidden');


        $('.product-filter-item')
            .removeClass('accordion-expanded');


        $('.accordion-title i')
            .removeClass('icon-arrow-up')
            .addClass('icon-arrow-down');


        $('.product-filter-btn[aria-pressed="true"]')
            .attr('aria-pressed', 'false');

    };


    /* -------------------------------------------------------
       Calculate Mobile Total Product Count
       ------------------------------------------------------- */

    common.calculateMobileTotalCount = function () {

        let totalCategoryProductsCount = 0;


        $('.js-product-filter-family').each(function () {

            let categoryProductsText =
                $(this)
                    .find('.categoryProductsCount')
                    .text()
                    .trim();


            let categoryProductsCount =
                parseInt(
                    categoryProductsText.replace(/[^\d]/g, ''),
                    10
                );


            if (isNaN(categoryProductsCount)) {

                categoryProductsCount = 0;

            }


            totalCategoryProductsCount +=
                categoryProductsCount;

        });


        $('.mobActiveProductsCount')
            .text(totalCategoryProductsCount);

    };


    /* -------------------------------------------------------
       GA4 Mobile Filter Event
       ------------------------------------------------------- */

    common.GA4FilterMobApplied = function (
        totalMobCount,
        activeFilterMobString
    ) {

        window.dataLayer = window.dataLayer || [];


        window.dataLayer.push({

            "event": "ga4_product_filter",

            "ga4_data": {

                "action_type": "Filter applied",

                "active_filter_choice":
                    activeFilterMobString,

                "filter_result_count":
                    totalMobCount

            }

        });

    };


    /* -------------------------------------------------------
       GA4 Desktop Filter Event
       ------------------------------------------------------- */

    common.GA4FilterApplied = function (
        totalCount,
        activeFilterValuesString
    ) {

        window.dataLayer = window.dataLayer || [];


        window.dataLayer.push({

            "event": "ga4_product_filter",

            "ga4_data": {

                "action_type": "Filter applied",

                "active_filter_choice":
                    activeFilterValuesString,

                "filter_result_count":
                    totalCount

            }

        });

    };


    /* -------------------------------------------------------
       Get Active Filter Label String
       ------------------------------------------------------- */

    common.getActiveFilterString = function () {

        let filterValues = [];


        $('.product-filter-applied-list .activeFilterLable')
            .each(function () {

                filterValues.push(
                    $(this)
                        .text()
                        .trim()
                );

            });


        return filterValues.join(', ');

    };


    /* -------------------------------------------------------
       Remove Product Card Empty Message Handling
       ------------------------------------------------------- */

    common.updateNoProductMessage = function () {

        $('.noProductmsg')
            .removeClass('noProductmsg');


        let allCardsHidden =
            $('.ProductDetailCard.js-product-filter-family')
                .filter(function () {

                    let isHidden =
                        $(this).hasClass('hidden') ||
                        $(this).is(':hidden');


                    let hasHiddenChildren =
                        $(this)
                            .find('.d-none')
                            .length > 0;


                    return isHidden || hasHiddenChildren;

                }).length ===
            $('.ProductDetailCard.js-product-filter-family').length;


        if (allCardsHidden) {

            $('.no_products_match')
                .addClass('noProductmsg');

        }

    };


    /* -------------------------------------------------------
       Refresh Product UI After Filter Action
       ------------------------------------------------------- */

    common.refreshFilterUI = function () {

        common.updateCategoryCountOnTargetFilter();


        $('.ProductFamily--Row')
            .addClass('opacityClass');


        setTimeout(function () {

            $('.ProductFamily--Row')
                .removeClass('opacityClass');

        }, 900);


        setTimeout(function () {

            common.hideZeroCard();

        }, 800);


        setTimeout(function () {

            common.updateNoProductMessage();

        }, 200);

    };


    /* -------------------------------------------------------
       Initial Common Setup
       ------------------------------------------------------- */

    common.initialize = function () {

        common.updateCategoryCountOnTargetFilter();


        setTimeout(function () {

            $('.ProductFamily--Row')
                .removeClass('opacityClass');

        }, 500);


        setTimeout(function () {

            common.hideZeroCard();

        }, 800);

    };


})(jQuery, window, document);
